import { dataPvShield } from 'dls-icons-data'
import { createIcon } from '../common'

const IconPvShield = /*#__PURE__*/createIcon(dataPvShield)
export default IconPvShield
